import {
  AEL_ERRORS_BATCH_SIZE,
  getAelErrorsUrl,
  serializeAelErrorsBatchBody,
} from 'src/internal/errors/transport/aelErrorsTransportSettings';
import createBatchingTransport from 'src/internal/transport/createBatchingTransport';

import type {
  AelErrorEvent,
  AelErrorsTransport,
  AelErrorsTransportConfig,
} from 'src/internal/errors/transport/types';

export default function createAelErrorsTransport(
  config: AelErrorsTransportConfig,
): AelErrorsTransport {
  return createBatchingTransport<AelErrorEvent>({
    fetch: config.fetch,
    service: config.service,
    flushSignal: config.flushSignal,
    getUrl: getAelErrorsUrl,
    serializeBatchBody: serializeAelErrorsBatchBody,
    contentType: 'application/json',
    batchSize: AEL_ERRORS_BATCH_SIZE,
  });
}
